export const LOGIN_FIELD_MIN_SYMBOLS = 3;

export enum LoginError {
  InvalidLogin = 'InvalidLogin',
  Offline = 'Offline',
  NoOrganization = 'NoOrganization',
}

export const LOGIN_ERROR_MESSAGE_KEYS: Record<LoginError, string> = {
  [LoginError.InvalidLogin]: 'auth_wrong_creds',
  [LoginError.Offline]: 'common_no_connection_to_server',
  [LoginError.NoOrganization]: 'auth_company_server_not_found_error',
};
